import { render, staticRenderFns } from "./cefloreco-mobile-app.vue?vue&type=template&id=4ce0ed90&scoped=true&"
import script from "./cefloreco-mobile-app.vue?vue&type=script&lang=js&"
export * from "./cefloreco-mobile-app.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-mobile-app.vue?vue&type=style&index=0&id=4ce0ed90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce0ed90",
  null
  
)

export default component.exports